import { Injectable } from "@angular/core";

@Injectable()
export class AppConstants {
    consentData: Object;
}